'use strict';

var React = require('react');

var SvgColorNoneMinor = function SvgColorNoneMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.64 5.853a6.968 6.968 0 0 1 1.36 4.147 1.75 1.75 0 0 1-1.75 1.75h-1.5a2 2 0 0 0-2 2v1.5a1.75 1.75 0 0 1-1.75 1.75 6.968 6.968 0 0 1-4.147-1.36l-1.015 1.014a.75.75 0 0 1-1.066-1.055l.005-.005 11.253-11.253.005-.005a.75.75 0 0 1 1.056 1.066l-.451.45Zm-.39 4.397h-1.5a3.5 3.5 0 0 0-3.5 3.5v1.5a.25.25 0 0 1-.25.25 5.474 5.474 0 0 1-3.071-.937l7.634-7.634a5.47 5.47 0 0 1 .937 3.071.25.25 0 0 1-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.38 3.869a7 7 0 0 0-9.512 9.512l1.118-1.117a5.5 5.5 0 0 1 7.278-7.278l1.117-1.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.975 6.275a1 1 0 1 0-1.2 1.2l1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }));
};
SvgColorNoneMinor.displayName = "ColorNoneMinor";

exports.SvgColorNoneMinor = SvgColorNoneMinor;
